import { useParams, Link } from 'react-router-dom';
import React, { useState } from 'react';
import { engineeringConsultancy, digitalServices, dedicatedResourcesServices } from './../Data/services';
import Breadcrumb from '../Components/Breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowRight } from '@fortawesome/free-solid-svg-icons';

function SingleServiceCategory() {
  const { category } = useParams();
  const [activeIndex, setActiveIndex] = useState(null);

  let services = [];
  let categoryTitle = '';
  let categoryDesc = '';

  if (category === "engineering-consultancy") {
    services = engineeringConsultancy;
    categoryTitle = "Engineering Solutions Services";
    categoryDesc = 'Our experienced engineers provide end-to-end consultancy services that ensure accuracy, efficiency, and excellence across every phase of your engineering projects.';
  } else if (category === "digital-services") {
    services = digitalServices;
    categoryTitle = "Digital & IT Services";
    categoryDesc = 'From data to design, our digital solutions empower businesses to streamline operations, enhance user experience, and scale intelligently.';
  } else if (category === "dedicated-resources-services") {
    services = dedicatedResourcesServices;
    categoryTitle = "Dedicated Resource Services";
    categoryDesc = 'Scale your business with on-demand talent. Our dedicated resource solutions give you access to skilled professionals for short-term tasks or long-term projects without the overhead of full-time hiring.';
  } else {
    categoryTitle = "Service Category Not Found";
  }

  const breadcrumbLinks = [
    { label: 'Home', url: '/' },
    { label: 'Services', url: '/services' },
    { label: categoryTitle }
  ];

  const renderCategoryTitle = (title) => {
    const words = title.split(' ');
    if (words.length >= 3) {
      return (
        <>
          {words[0]} <span>{words[1]}</span> {words.slice(2).join(' ')}
        </>
      );
    } else if (words.length === 2) {
      return (
        <>
          {words[0]} <span>{words[1]}</span>
        </>
      );
    } else {
      return title;
    }
  };

  const handleToggle = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null); // Same index clicked   collapse
    } else {
      setActiveIndex(index); // Open new one
    }
  };

  return (
    <>
      <Breadcrumb pageTitle={categoryTitle} breadcrumbLinks={breadcrumbLinks} />
      <div className="service-area pd-top-112">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-10 text-center mb-3">
              <div className="section-title">
                <h2 className="title">{renderCategoryTitle(categoryTitle)}</h2>
                <p>{categoryDesc}</p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-xl-10">
              <div className="row">
                {services.length > 0 ? (
                  services.map((service, index) => (
                    <div key={index} className="col-lg-4 col-md-6 mb-1">
                      <div className="single-service wow animated fadeInUp" data-wow-duration="0.4s" data-wow-delay={(index + 1) * 0.1 + "s"}>
                        <img src={service.icon} alt={service.title} />
                        <Link to={service.link}>
                          <h6 style={{ cursor: 'pointer' }}>
                            {service.title}
                          </h6>
                        </Link>
                        <p className='text-left spacing'>{service.description}</p>
                        {/* <ul>
                      {service.services && service.services.length > 0 ? (
                        service.services.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))
                      ) : null}
                    </ul> */}
                        <div class="read-more">
                          
                          <Link to={service.link}>Read More <FontAwesomeIcon icon={faLongArrowRight} fontSize={15} className='ml-2' /></Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center">
                    <p>No services found for this category.</p>
                    <Link to="/services" className="btn btn-primary mt-3">Go Back to Services</Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleServiceCategory;
